import { useCallback } from 'react';
import { useData } from '../contexts/index';
import { useAuth } from '../contexts/AuthContext';
import { publishDrawResults } from '../services/plays/publishResults';

export function usePublishDrawResults() {
  const { adapter } = useData();
  const { user } = useAuth();

  const publish = useCallback(async (
    vals: [string, string, string],
    options: { source?: string; window?: 'day' | 'night'; dayKey?: string } = {},
  ) => {
    return publishDrawResults(adapter, vals, {
      ...options,
      publishedBy: user?.id,
      publishedByName: user?.name,
    });
  }, [adapter, user?.id, user?.name]);

  return { publish };
}
